import emojiRegex from 'emoji-regex/RGI_Emoji';

const TWEMOJI_BASE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg';

export const getEmojiRegex = () => emojiRegex();

const getEmojiCodePoint = (emoji: string) => {
  return Array.from(emoji)
    .map((character) => character.codePointAt(0))
    .filter((codePoint): codePoint is number => !!codePoint)
    .filter((codePoint) => codePoint !== 0xfe0f)
    .map((codePoint) => codePoint.toString(16))
    .join('-');
};

export const getEmojiImageUrl = (emoji: string) => `${TWEMOJI_BASE_URL}/${getEmojiCodePoint(emoji)}.svg`;
